export default __webpack_public_path__ + "static/zoom-in-4d0a266ee00cb14a43fd1337c7f45517.gif";